import { create } from 'zustand';
import customersApi from '../api/customer';
import { CustomerInfo } from '../common/types';

type CustomersStore = {
  hasLoaded: boolean;
  customers: CustomerInfo[];
  loading: boolean;
  error: unknown | null;
  fetchCustomers: () => Promise<void>;
  toggleSuspended: (id: number, suspended: boolean) => Promise<void>;
};

const useCustomers = create<CustomersStore>((set, get) => ({
  hasLoaded: false,
  customers: [],
  loading: false,
  error: null,
  fetchCustomers: async () => {
    if (get().loading) {
      return;
    }
    set({ loading: true, hasLoaded: true });
    try {
      const result = await customersApi.getAll();
      set({ customers: result.data ?? [], error: null });
    } catch (err) {
      console.error(err);
      set({ error: err });
    } finally {
      set({ loading: false })
    }
  },
  toggleSuspended: async (id: number, suspended: boolean) => {
    set({ loading: true });
    try {
      await customersApi.toggleSuspended(id, suspended);
      await get().fetchCustomers();
    } catch (err) {
      console.error(err);
    } finally {
      set({ loading: false });
    }
  }
}));

export default useCustomers;

if (!useCustomers.getState().hasLoaded) {
  useCustomers.getState().fetchCustomers();
}
